// extracted by mini-css-extract-plugin
module.exports = {"header":"SectionHeader_header__3BkgE","headerAction":"SectionHeader_headerAction__GgibG","headerContent":"SectionHeader_headerContent__346HG"};